import React from 'react';
import { usePowermailSettings } from '../../context/PowermailContext';
import { ZdsCard, ZdsIcon, ZdsLink } from '@zig-design-system/ui-components-react';
import { Submit } from './Submit';
export const InvisibleRecaptcha = ({ field, submitting }) => {
    const powerMailSettings = usePowermailSettings();
    if (powerMailSettings.invisibleRecaptchaSiteKey && powerMailSettings.invisibleRecaptchaSiteKey !== 'abcdef') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "g-recaptcha", "data-sitekey": powerMailSettings.invisibleRecaptchaSiteKey, "data-callback": "onSubmit", "data-size": "invisible" }),
            React.createElement(Submit, { field: field, submitting: submitting })));
    }
    return (React.createElement(ZdsCard, { alignment: "center" },
        React.createElement(ZdsIcon, { name: "warning_amber", library: "mui", slot: "icon", size: "xxl" }),
        React.createElement("span", { slot: "header" }, "Please register your domain!"),
        React.createElement("span", { slot: "body" },
            "Register your domain to",
            ' ',
            React.createElement(ZdsLink, { link: "https://www.google.com/recaptcha/" }, "https://www.google.com/recaptcha/"),
            " and enter your sitekey in TypoScript Constants like",
            React.createElement("br", null),
            React.createElement("code", { className: "zds-caption" }, "plugin.tx_invisiblerecaptcha.sitekey = abcdef"))));
};
